import React from "react";
import { useSelector } from "react-redux";
import { Route, Switch } from "react-router-dom";
import LoadHistoryPage from "../LoadHistory/LoadHistoryPage";
import FarmList from "./FarmList";
import { usePermission, isToday } from "../../helpers/common";
import SeedHistoryContent from "../seedHistory/SeedHistoryContent";
import LogisticsHistoryContent from "../Logistics/LogisticsHistoryContent";
import { EgRegionLocation } from "../equipment-group";

const Farm = ({ match }) => {
	
	const { range } = useSelector((state) => state.analyze.searchParams);
	const allow = usePermission();
	const isAllowView = allow("farm", "view") ? isToday(range) : false;

	return (
		<Switch>
			{isAllowView && (
				<Route exact path={`${match.path}/farm/list`} component={FarmList} />
			)}
			<Route
				exact
				path={`${match.path}/loadhistory/:title?`}
				component={LoadHistoryPage}
			/>
			<Route
				exact
				path={`${match.path}/seedhistory/:type?/:isTruck?/:egId?/:crewId?`}
				component={SeedHistoryContent}
			/>
			<Route
				exact
				path={`${match.path}/logisticshistory/:type?/:isTruck?/:egId?/:crewId?`}
				component={LogisticsHistoryContent}
			/>
			<Route
				exact
				path={`${match.path}/eg-region-location/:egId?`}
				component={EgRegionLocation}
			/>
		</Switch>
	);
};

export default Farm;
